export enum ProcessStateEnum {
  '계좌이체대기' = '계좌이체대기' /* 고객 : 가상계좌 결제 선택 후 아직 입금 확인 되지 않은 상태 */,
  '제조준비완료' = '제조준비완료' /* 고객 : 가상계좌 입금 확인 or 신용카드 결제 완료 */,
  '제조시작' = '제조시작' /* 파트너 : 제조시작 */,
  '배송시작' = '배송시작' /* 파트너 : 거래완료 후 배송지 입력 완료 */,
  '거래완료' = '거래완료' /* 고객 : 제품 수령 및 검품 완료 후 고객  */,
  '발주서거부' = '발주서거부' /* 파트너 : 고객이 발행한 발주서 거부 */,
  '결제취소대기' = '결제취소대기' /* 고객 : 파트너에게 결제취소 요청 */,
  '결제취소완료' = '결제취소완료' /* 파트너 : 고객의 결제취소요청 승인*/,
  '환불대기' = '환불대기' /* 고객 : 제조시작 후 파트너에게 환불요청 */,
  '환불완료' = '환불완료' /* 파트너 : 고객 환불요청 승인 */
}
